import * as React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import PageModules from '../components/PageModules';
import PageMeta from '../components/PageMeta';
import { TitleContext } from '../context';
import Wayfinder from '../components/Wayfinder';
import { getPageBreadcrumbs, homeIfNoBreadcrumbs } from '../helpers/breadcrumbs';

const SuperTemplate = (props) => {
  const { data } = props;
  const { page, siblings, pages } = data;
  const { seo, contentBuilder, wayfinderSettings, rightToLeftContent } = page;
  const { modules } = contentBuilder;
  const breadcrumbs = homeIfNoBreadcrumbs(getPageBreadcrumbs(page), page);

  return (
    <Layout>
      <PageMeta metaFields={{ seo }} />
      <TitleContext.Provider value={page.title}>
        <div className={page.rightToLeftContent?.rightToLeftContent ? 'rtl-content' : ''}>
          <PageModules modules={modules} childPages={pages} breadcrumbs={breadcrumbs} />
        </div>
        {!wayfinderSettings ||
          (!wayfinderSettings.hideWayfinder && <Wayfinder links={siblings.nodes} parent_title={breadcrumbs?.parent_page?.title} />)}
      </TitleContext.Provider>
    </Layout>
  );
};

export default SuperTemplate;

export const query = graphql`
  query superTemplate($id: String!, $parentDatabaseId: Int, $databaseId: Int) {
    page: wpPage(id: { eq: $id }) {
      title
      parentDatabaseId
      wayfinderSettings {
        hideWayfinder
      }
      rightToLeftContent {
        rightToLeftContent
      }
      link
      databaseId
      ...PageParentGrandparent
      ...AcfSuperTemplateModulesFragment
      ...SeoPageFragment
    }
    pages: allWpPage(filter: { parentDatabaseId: { eq: $databaseId } }, sort: { menuOrder: ASC }) {
      edges {
        node {
          id
          title
          link
          listingExtras {
            excludeFromListing
            listingImage {
              altText
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 768, quality: 80, layout: CONSTRAINED)
                }
              }
            }
          }
          pageExcerpt {
            excerpt
          }
          featuredImage {
            node {
              altText
              caption
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 528, quality: 80, layout: CONSTRAINED)
                }
              }
            }
          }
        }
      }
    }
    ...SiblingsFragment
  }
`;
